exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "thead[class*='ant-table-thead'] th {\n  /* background-color: #dcf0ee !important; */\n  border-top: 3px solid #008080 !important;\n  font-family: proxima-nova;\n  font-size: 11px;\n  font-weight: 700;\n  -ms-flex-pack: center;\n      justify-content: center;\n  padding: 0;\n  /* height: 49px; */\n  text-align: center;\n}\n\ntbody[class*='ant-table-tbody'] tr:nth-child(even) {\n  background-color: #f5f9fc !important;\n}\n\ntbody[class*='ant-table-tbody'] tr {\n  border-right: 1px solid #e9e9e9 !important;\n  cursor: pointer !important;\n}\n\ntbody[class*='ant-table-tbody'] td {\n  border-right: 1px solid #e9e9e9 !important;\n  cursor: pointer !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /builds/alivecorbackend/kardia-pro/node_modules/css-loader?{"importLoaders":1,"modules":{"localIdentName":"[name]__[local]___[hash:base64:5]"}}!/builds/alivecorbackend/kardia-pro/node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./src/views/components/Common/Table/CustomTableComponent.css
// module id = 9959
// module chunks = 25